<template>
    <div />
</template>
<script >
import { use } from '@fegobull/webapi';
import { isMoomoo, isNN } from '@futuweb/tool-browser';
import { defineExpose, defineProps, watch, useAttrs, computed } from 'vue-demi';
import { quickCreateModal } from '../components/Modal/create';
import { useI18n } from '../lang';
import { consoleImage } from '../poster';
import { nnShareSnapShot } from '../utils/share';
import { useShare } from './use';
import { copyText } from './utils';
const __sfc_main = {};
__sfc_main.props = ['shareConfig', 'poster', 'qrTitleImage', 'shareLinkVar', 'isPriorityStructuredShare'];
__sfc_main.setup = (__props, __ctx) => {
  const {
    useToast,
    useVariable
  } = use;
  const Toast = useToast();
  const $t = useI18n();
  const attrs = useAttrs();
  const reportAttrs = computed(() => {
    return {
      element_id: attrs?.['data-id'] || '',
      element_name: attrs?.['data-name'] || ''
    };
  });
  /**
   * @typedef {Object} Props
   * @property {string} shareConfig
   * @property {string} poster
   * @property {string} qrTitleImage
   */
  /**
   * @type {Props}
   */
  const props = __props;
  const {
    state
  } = useShare(props.shareConfig, props.poster);
  function updateFegoVariable(key, value) {
    try {
      const variable = useVariable();
      variable[key] = value;
    } catch (error) {
      console.error(error);
    }
  }
  if (props.shareLinkVar) {
    if (state.shareUrl) {
      updateFegoVariable(props.shareLinkVar, state.shareUrl);
    }
    watch(() => state.shareUrl, newVal => {
      if (newVal) {
        updateFegoVariable(props.shareLinkVar, newVal);
      }
    });
  }
  function copyShareUrl() {
    copyText(state.shareUrl);
    Toast.msg({
      message: $t('share.copySuccess'),
      duration: 2000
    });
  }
  const shareData = $t('shareData');
  function showPosterShare() {
    const {
      poster,
      shareUrl
    } = state;
    nnShareSnapShot(poster, {
      link: shareUrl,
      image: shareData.imgwx || '',
      title: shareData.title || '',
      desc: shareData.desc || '',
      isPriorityStructuredShare: props.isPriorityStructuredShare,
      reportAttrs: reportAttrs.value
    }, () => {
      console.log('分享成功');
    });
  }
  function showFaceToFaceShare() {
    const {
      qrCode
    } = state;
    consoleImage(props.qrTitleImage);
    consoleImage(qrCode);
    quickCreateModal(() => import('../components/QrContent/index.vue'), {
      qrcode: qrCode,
      qrTitleImage: props.qrTitleImage
    });
  }
  return Object.assign({}, {
    showShare: () => {
      if (!state.shareUrl) {
        return;
      }
      if (state.poster) {
        consoleImage(state.poster);
      }
      // 1.判断是否是牛牛或者moomoo客户端
      // 1.1 如果是牛牛客户端唤起海报分享
      // 1.2 如果不是牛牛客户端,复制链接,提示复制链接成功
      if (isNN() || isMoomoo()) {
        if (state.poster) {
          showPosterShare();
        } else {
          copyShareUrl();
        }
      } else {
        copyShareUrl();
      }
    },
    showFaceToFaceShare: () => {
      if (!state.qrCode || !props.qrTitleImage) {
        return;
      }
      showFaceToFaceShare();
    }
  });
};
export default __sfc_main;
</script>

<style lang="less" scoped>
div {
    display: none;
}
</style>
